export function getErrorMessage(error) {
    if (error != null && typeof error === 'object') {
        if ('message' in error && typeof error.message === 'string') {
            return error.message;
        }
        else if ('toString' in error && typeof error.toString === 'function') {
            try {
                const message = error.toString();
                if (typeof message === 'string') {
                    return message;
                }
            }
            catch (_a) {
                return 'Unknown error';
            }
        }
    }
    else if (typeof error === 'string') {
        return error;
    }
    return 'Unknown error';
}
